export default "__VITE_ASSET__0c10890b__"